import React from 'react'
import RectLoader from '../shared/RectLoader'
import Modal from '../shared/Modal'
import Momment from 'moment'
import {t} from '../../../i18n'
import { formatNumber, CloseMD } from '../normalizer';

const ObjectiveSection = ({title, h3Override, children}) => (
  <div className="gl-objectives__section">
    {h3Override || <h3 className="gl-objectives__section-title">{title}</h3>}
    <div className="gl-objectives__section-body">
      {children}
    </div>
    <hr className="gl-objectives__line"/>
  </div>
)

const ObjectiveH3 = ({title, writtenProgress}) => (
  <div className="gl-objectives__rule-header">
    <h3 className="gl-objectives__rule-title">{title}</h3>
    <p className="gl-objectives__rule-progress">{writtenProgress}</p>
  </div>
)

const DisplayReward = ({type,reward,currencyLabel}) => {
  let normalizedType = type
  switch(type){
    case 'points':
      normalizedType = currencyLabel
      break;
    default:
      normalizedType = type
      break;
  }

  return (
  <div>
    {formatNumber(reward)} {normalizedType}
  </div>
  )}

const ObjectiveSectionContainer = ({rules, currencyLabel}) => (
  rules.map(({id, name, target, percentage, progress, award, quantity}) => {
    const H3 = <ObjectiveH3 title={name} writtenProgress={progress +" de " +target}/>
    return(
      <ObjectiveSection key={id} title={name} h3Override={H3} >
        <div className="gl-objectives__progress gl-objectives__progress--rule">
          <RectLoader thin progress={Number(percentage)}/>
        </div>
        <DisplayReward type={award} reward={quantity} currencyLabel={currencyLabel}/>
      </ObjectiveSection>
    )
  })
)

const ObjectiveModal = ({selected, onUnselectObject, currencyLabel}) => {
  return (
    <Modal show={selected} untoggle={onUnselectObject}>
      <div className="gl2026-modal__header">
        <h4 className="gl2026-modal__title">{selected.name}</h4>
        <button type="button" className="gl2026-modal__close" onClick={onUnselectObject} aria-label="Fechar">
          <CloseMD />
        </button>
      </div>
      <div className="gl2026-modal__body">
        <ObjectiveSection title="Descrição">
          <div className="custom-inner-html gl-objectives__description">
            <p dangerouslySetInnerHTML={{ __html: selected.description }}></p>
            {!selected.description && <p>Sem descrição</p>}
          </div>
        </ObjectiveSection>

        <ObjectiveSection title="Atingimento">
          <div className="gl-objectives__progress">
            <RectLoader progress={Number(selected.percentage)}/>
          </div>
        </ObjectiveSection>

        <ObjectiveSectionContainer rules={selected.rules} currencyLabel={currencyLabel} />

        <div className="gl-objectives__end-date">
          Termina a <span>{new Momment(selected.end_date).format(t('date-format'))}</span>
        </div>
      </div>
    </Modal>
  )
}

export default ObjectiveModal
